import styled from 'styled-components'
import fonts from '../../styled/fonts'

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 20px;
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 16px;
	margin-bottom: 20px;
`

export const DonutWrapper = styled.div`
	position: relative;
	width: 80px;
	height: 80px;
	flex-shrink: 0;
`

export const DonutPercentage = styled.span`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 16px;
	font-weight: ${fonts.fontWeight.semibold};
	color: ${props => props.theme.colors.text.titleText};
`

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`

export const BoldSpan = styled.span`
	font-weight: ${fonts.fontWeight.semibold};
`

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const InfoPopupAnchor = styled.div`
	position: relative;
	${props => props.$active && 'z-index: 1010;'}
	display: inline-flex;
	align-self: flex-start;
`

export const InfoIconCircle = styled.span`
	position: relative;
	z-index: 1002;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background: ${props => props.$background};
`

export const InfoPopupOverlay = styled.div`
	position: fixed;
	inset: 0;
	background: ${props => props.theme.colors.greys.modalOverlay};
	z-index: 1000;
`

export const InfoPopup = styled.div`
	position: absolute;
	top: calc(100% + 8px);
	left: 0;
	z-index: 1001;
	width: min(420px, 85vw);
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	border-radius: 16px;
	background: ${props => props.theme.colors.brand.white};
`
